import { ShoppingBag } from "lucide-react";
import { CRITTERS, SHOP_ITEMS } from "../../data/dolopals";
import { SectionHeading } from "../SectionHeading";
import { isTradeTuesday, tradeValue } from "./utils";
import { CritterShape } from "./CritterShape";

export function ShardShop({ exp, buy, equip, tradeCritter }) {
  return (
    <section className="shard-shop" data-testid="shard-shop">
      <SectionHeading
        eyebrow="SCRAP-SHARD EXCHANGE // SPEND THE HAUL"
        title="The shard shop."
        text="Expedition loot, spent properly. Frames wrap every card in your roster; banner cosmetics restyle the page banner up top; radar upgrades make the Titan Tracker kinder — longer spikes, slower worms, a shield for your combo. Dauber inks and stamp shapes restyle your Dolos Bingo card. Equip and unequip freely."
      />
      <div className="shop-grid">
        {SHOP_ITEMS.map((item) => {
          const owned = exp.owned.includes(item.id);
          const equipped = item.kind === "upgrade" ? owned : exp[item.kind] === item.id;
          const afford = exp.shards >= item.cost;
          return (
            <article key={item.id} className={`shop-card ${equipped ? "is-equipped" : ""}`} style={{ "--sc": item.color }} data-testid={`shop-card-${item.id}`}>
              <div className="shop-swatch">
                <span className={item.kind === "daub" ? "swatch-ink" : item.kind === "stamp" ? `swatch-stamp swatch-${item.id.slice(6)}` : ""} />
              </div>
              <div className="shop-body">
                <h3>{item.name}</h3>
                <em>{item.kind === "frame" ? "CARD FRAME" : item.kind === "banner" ? "BANNER COSMETIC" : item.kind === "skin" ? "RADAR SKIN" : item.kind === "daub" ? "BINGO DAUBER INK" : item.kind === "stamp" ? "BINGO DAUB STAMP" : "RADAR UPGRADE"}</em>
                <p>{item.desc}</p>
                {owned ? (
                  item.kind === "upgrade" ? (
                    <span className="shop-action is-owned" data-testid={`shop-equipped-${item.id}`}>ALWAYS ON</span>
                  ) : (
                    <button
                      type="button"
                      className={`shop-action is-owned ${equipped ? "is-equipped" : ""}`}
                      onClick={() => equip(item.id)}
                      data-testid={`shop-equip-${item.id}`}
                    >
                      {equipped ? "EQUIPPED — TAP TO REMOVE" : "EQUIP"}
                    </button>
                  )
                ) : (
                  <button
                    type="button"
                    className="shop-action"
                    onClick={() => buy(item.id)}
                    disabled={!afford}
                    data-testid={`shop-buy-${item.id}`}
                  >
                    <ShoppingBag size={12} /> {item.cost} SHARDS{afford ? "" : " — KEEP EXPEDITING"}
                  </button>
                )}
              </div>
            </article>
          );
        })}
      </div>
      {Object.keys(exp.critterDupes || {}).length > 0 || Object.keys(exp.shinyDupes || {}).length > 0 ? (
        <div className="critter-trades" data-testid="critter-trades">
          <p className="critter-trades-head">
            {isTradeTuesday() ? "TRADE TUESDAY — DOUBLE PAYOUTS ON EVERYTHING" : "CRITTER TRADES — DUPLICATES CASH IN · SHINIES PAY DOUBLE · 2X ON TUESDAYS"}
          </p>
          {CRITTERS.filter((c) => (exp.critterDupes || {})[c.id] > 0).map((c) => (
            <div className="critter-trade-row" key={c.id} data-testid={`critter-trade-${c.id}`}>
              <span className="critter-figure is-small" style={{ "--cc": c.color }}>
                <CritterShape shape={c.shape} color={c.color} size={34} />
              </span>
              <strong>{c.name} <em>×{exp.critterDupes[c.id]}</em></strong>
              <button type="button" onClick={() => tradeCritter(c.id)} data-testid={`critter-trade-btn-${c.id}`}>
                TRADE — +{tradeValue()} SHARDS
              </button>
            </div>
          ))}
          {CRITTERS.filter((c) => (exp.shinyDupes || {})[c.id] > 0).map((c) => (
            <div className="critter-trade-row is-shiny" key={`shiny-${c.id}`} data-testid={`critter-trade-shiny-${c.id}`}>
              <span className="critter-figure is-small" style={{ "--cc": "#ffd700" }}>
                <CritterShape shape={c.shape} color="#ffd700" size={34} />
              </span>
              <strong>SHINY {c.name} <em>×{exp.shinyDupes[c.id]}</em></strong>
              <button type="button" onClick={() => tradeCritter(c.id, true)} data-testid={`critter-trade-shiny-btn-${c.id}`}>
                TRADE — +{tradeValue() * 2} SHARDS
              </button>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
